import { getApiBaseUrl } from '../config/api';

const API_URL = getApiBaseUrl();

/**
 * Save or unsave a post. Pass `saved` to set the state explicitly.
 * Reposts are saved as their original post (the response's post_id).
 */
export async function setPostSaved(userId, postId, saved) {
  try {
    const res = await fetch(`${API_URL}/toggle_save_post.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: userId, post_id: postId, saved }),
    });
    return await res.json();
  } catch (err) {
    console.error('toggle_save_post failed', err);
    return { success: false, message: 'Network error. Please try again.' };
  }
}

/** type: 'all' | 'posts' | 'articles' | 'jobs' | 'questions' */
export async function fetchSavedPosts(userId, { type = 'all', limit = 20, offset = 0 } = {}) {
  try {
    const params = new URLSearchParams({
      user_id: String(userId),
      type,
      limit: String(limit),
      offset: String(offset),
    });
    const res = await fetch(`${API_URL}/get_saved_posts.php?${params.toString()}`);
    return await res.json();
  } catch (err) {
    console.error('get_saved_posts failed', err);
    return { success: false, items: [], has_more: false };
  }
}

/** Detail-page route for a saved item, matching the feed card links. */
export function savedItemPath(item) {
  switch (item?.post_type) {
    case 'article':
      return `/home/article/${item.id}`;
    case 'blog':
      return `/home/blog/${item.id}`;
    case 'hiring':
      return `/home/hiring/${item.id}`;
    case 'looking_for_job':
      return `/home/looking-for-job/${item.id}`;
    case 'question':
      return `/home/question/${item.id}`;
    default:
      return `/home/post/${item.id}`;
  }
}
